export const orderNewCardFormInputNames = {
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postal: 'postal',
  isDefault: 'isDefault',
  memberList: 'memberList',
} as const;
